exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".xue-lightup-mask {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.15);\n  z-index: 99; }\n\n.xue-lightup-img-wrapper {\n  position: fixed;\n  z-index: 100; }\n  .xue-lightup-img-wrapper > .xue-lightup-img {\n    width: 100%;\n    height: 100%;\n    border-radius: 4px; }\n\n.xue-lightup-scale {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: transparent;\n  z-index: -9999;\n  pointer-events: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/packages/lightup/style/index.scss
// module id = 175
// module chunks = 0